






































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeSuratKeteranganKelahiran } from "@/store/modules/SuratKeteranganKelahiranStore";
import SklSvc from "@/services/SuratKeteranganKelahiranService";
import SuratKeteranganKelahiranDetail from "./SuratKeteranganKelahiranDetail.vue";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: {
    SuratKeteranganKelahiranDetail
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class SuratKeteranganKelahiranList extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string;

  storeSkl = storeSuratKeteranganKelahiran;
  showDetail = false;
  editData: any = null;
  isReadonly = false;
  isReadOnly!: () => boolean;

  get pageReadOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    { text: "Tgl Lahir", value: "tanggal_lahir", width: "120px" },
    { text: "Nama Bayi", value: "nama_bayi" },
    { text: "Nomor SKL", value: "nomor", width: "200px" },
    { text: "Aksi", value: "actions", sortable: false, width: "120px" }
  ];

  mounted() {
    this.loadData();
  }

  async loadData() {
    await storeSuratKeteranganKelahiran.getByRegister(this.register);
  }

  tambah() {
    this.editData = null;
    this.isReadonly = false;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.isReadonly = this.pageReadOnly;
    this.showDetail = true;
  }

  cetakPdf(item: any) {
    SklSvc.printPdf(item.id);
  }

  async hapus(item: any) {
    if (!confirm("Hapus Surat Keterangan Kelahiran ini?")) return;
    try {
      const resp = await SklSvc.destroy(item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus");
        this.loadData();
      }
    } catch {
      // handled by service
    }
  }

  onBack() {
    this.showDetail = false;
    this.editData = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }

  formatDate(val: string) {
    if (!val) return "-";
    return moment(val).format("DD/MM/YYYY");
  }
}
